export const xor = (a: any, b: any) => {
  const boolA = Boolean(a)
  const boolB = Boolean(b)
  return (boolA && !boolB) || (!boolA && boolB)
}
